"use strict";

exports.__esModule = true;
exports.AdvancedTimelineQueryController = AdvancedTimelineQueryController;
exports.shortCircuitResponse = shortCircuitResponse;
var _react = _interopRequireDefault(require("react"));
var _libTimeline = require("@vimana/lib-timeline");
var _LayoutSettingsContext = require("../../ConfigurableLayout/LayoutSettingsContext");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _APIQueryController = require("../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Queries a given timeline and makes the results available to consumers
 * via a render prop.
 */
function AdvancedTimelineQueryController(_ref) {
  var timelineName = _ref.timelineName,
    interval = _ref.interval,
    body = _ref.body,
    children = _ref.children;
  var layoutSettings = _react["default"].useContext(_LayoutSettingsContext.LayoutSettingsContext);
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var shouldSliceResponse = layoutSettings && layoutSettings.editorSettings.editMode;
  var startMillis = interval.startMillis,
    endMillis = interval.endMillis;
  if (endMillis <= startMillis) {
    return children(shortCircuitResponse());
  }
  var startDate = new Date(startMillis);
  var endDate = new Date(endMillis);
  var type = Array.isArray(timelineName) ? timelineName : [timelineName];
  var reqBody = Object.assign({
    start: startDate.toISOString(),
    end: endDate.toISOString(),
    type: type
  }, body);
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    key: "" + interval.startMillis + interval.endMillis,
    body: reqBody,
    load: function load() {
      return dataAccessor.getAdvancedTimeline(reqBody);
    },
    normalizeResponse: normalizeTimeline(shouldSliceResponse)
  }, children);
}
var normalizeTimeline = function normalizeTimeline(shouldSliceResponse) {
  return function (input) {
    return shouldSliceResponse ? input.slice(0, 30).sort(_libTimeline.compareTimelineItemsByInterval) : input.sort(_libTimeline.compareTimelineItemsByInterval);
  };
};
function shortCircuitResponse() {
  return {
    data: [],
    error: undefined,
    loaded: true,
    fetching: false,
    reload: function reload() {
      return new Promise(function (resolve) {
        return resolve([]);
      });
    },
    update: function update() {}
  };
}